import { type ResponseItemType } from '@/common/types/response.type';
import type { VendorItem } from '@/common/types/vendor.type';
import { useQuery } from '@tanstack/react-query';
import { VENDOR_ITEM_QUERY_KEY } from '@/common/constants/vendor-item-query.constant';
import Client from '@/common/utils/client.utility';
import serializeIdentifier from '@/common/utils/serialize-identifier.utility';

export interface VendorItemQueryParams {
  identifier: string;
}

export interface VendorItemResponse extends VendorItem {}

export type VendorItemType = (
  params: VendorItemQueryParams,
  disabelToast?: boolean
) => Promise<ResponseItemType<VendorItemResponse>>;

export const getVendorItem: VendorItemType = async (params, disableToast) => {
  const client = new Client(disableToast);
  const { identifier } = params;

  const slug = serializeIdentifier(identifier);
  return await client.get(`/v1/Shopper/Storefronts/${slug}`);
};

export function useGetVendorItem({
  enabled,
  query,
  disableToast = false,
}: {
  enabled?: boolean;
  query: VendorItemQueryParams;
  disableToast?: boolean;
}) {
  return useQuery<ResponseItemType<VendorItemResponse>, Error>({
    queryFn: async () => await getVendorItem(query, disableToast),
    queryKey: [VENDOR_ITEM_QUERY_KEY, query],
    enabled,
    staleTime: 600000,
  });
}
